import { useTranslation } from 'react-i18next';
import MemberForm from '../components/MemberForm';
import PaymentInfo from '../components/PaymentInfo';

export default function Member({ formData, handleInputChange, handleSubmit }) {
  const { t } = useTranslation();

  return (
    <section className="min-h-screen px-4 sm:px-6 py-16 sm:py-20 bg-gray-50">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-3xl sm:text-4xl font-light tracking-tight mb-4 text-center">
          {t('form.title')}
        </h1>
        <div className="h-[2px] w-16 bg-gray-900 mx-auto mb-10 sm:mb-12"></div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-10">
          <div className="bg-white shadow-sm border border-gray-100 rounded-2xl p-6 sm:p-8">
            <MemberForm
              formData={formData}
              handleInputChange={handleInputChange}
              handleSubmit={handleSubmit}
            />
          </div>
          <div className="bg-white shadow-sm border border-gray-100 rounded-2xl p-6 sm:p-8">
            <PaymentInfo />
          </div>
        </div>
      </div>
    </section>
  );
}